import styled from 'styled-components'
import {device} from '../../media_queries'

const MainOtros = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: -1;
  background-color: #ffffff;
  height: auto;
  @media ${device.mobileS} {
  }
  @media ${device.tablet} {
  }
  @media ${device.laptop} {
    width: 100%;
    height: 100%;
  }
  @media ${device.desktop} { 
  }
`

const GeneralCont= styled.div`
  width:90vw;
  height: auto;
  border: 1px solid black;
  &>h3{
    font-family:'panton-bold';
    color:·#C90045;
  }

  @media ${device.mobileS} {
  }
  @media ${device.tablet} {
  }
  @media ${device.laptop} {
  }
  @media ${device.desktop} { 
  }
`

const ClientesContainer = styled.div`
    display: flex;
    width:90vw;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-bottom: 5vh;
    @media ${device.mobileS} {
      }
    @media ${device.tablet} { 
      }
    @media ${device.laptop} {
      }
    @media ${device.desktop} {
      }
`
const OtrosClientes = styled.div`
width: 25vw;
&>img{
    height:auto;
    width:15vw;
    }

    @media ${device.mobileS} {
      &>p{
        font-size:.5em;
      }
      }

    @media ${device.tablet} {
      &>p{
        font-size:.8em;
      }
}
    @media ${device.laptop} {
      &>p{
        font-size:1em;
      }
      }
    @media ${device.desktop} {
      &>p{
        font-size:1em;
      }
}
`

const CarContainer = styled.div`
  display: flex;
  width:90vw;
  height: auto;
  justify-content: space-around;
  `

export { MainOtros, GeneralCont, ClientesContainer, OtrosClientes , CarContainer }


/*display: flex;
    flex-wrap: wrap;
    width:90vw;
    height: 80vh;
    justify-content: center;
    color: black;
    border: 2px solid #BEBEBE;
    box-shadow: 0 2px 10px 0 rgba(0, 34, 91, 0.11);*/